import React, {useEffect} from 'react';
import PulsoidClient from '../PulsoidClient';

export const ClarityInit = () => {
  useEffect(() => {
    // @ts-ignore
    if (window.clarity && clarityEnabled()) {
      new PulsoidClient({
        noAuthRedirect: true,
      })
        .getUserInfo()
        .then((userInfo) => {
          if (userInfo != null) {
            if (userInfo.id) {
              try {
                // @ts-ignore
                window.clarity('identify', '123456789');
              } catch (e) {
                console.error('error while identify', e);
              }
            }
          }
        });
    }
  }, []);
  return <></>;
};

const clarityEnabled = () => {
  return (
    !window.location.host.includes('127.0.0.1') &&
    !window.location.host.includes('localhost')
  );
};
